import { LOCAL_DB_PERSONA_KEY } from '../config'
import { findRow, readTable } from '../store/localDb.store'
import type { QueryContext, SchemaDefinition } from '../types/localDb.types'

/** Persona aktif (id `directus_users`) yang dipakai sebagai `user_created`/`$CURRENT_USER`. */
export function currentUserId(): string {
  return localStorage.getItem(LOCAL_DB_PERSONA_KEY) ?? ''
}

export function createQueryContext(schema: SchemaDefinition): QueryContext {
  return {
    userId: currentUserId(),
    now: new Date(),
    schema,
    resolve: (collection, id) => findRow(collection, id),
    children: (collection, field, parentId) =>
      readTable(collection).filter(row => {
        const value = row[field]
        const key = typeof value === 'object' && value !== null ? (value as { id?: unknown }).id : value
        return String(key) === String(parentId)
      })
  }
}

/** Kolom audit wajib Directus (8 field) untuk row baru. */
export function auditFieldsForCreate(): Record<string, unknown> {
  const now = new Date().toISOString()
  return {
    status: 'published',
    sort: null,
    user_created: currentUserId() || null,
    date_created: now,
    user_updated: null,
    date_updated: null,
    user_deleted: null,
    date_deleted: null
  }
}

export function auditFieldsForUpdate(): Record<string, unknown> {
  return { user_updated: currentUserId() || null, date_updated: new Date().toISOString() }
}

export function newId(): string {
  return crypto.randomUUID()
}
